export default "__VITE_ASSET__116574c8__"